import { api_type } from "../services/axios";
import { ACCESS_LEVEL, getModuleLabel } from "./constants";

export const ACCESS_DATA_API = "/data";

export const getAccessDataApiPath = () => `/${api_type}${ACCESS_DATA_API}`;

export const EMPTY_ACCESS = {
  id: null,
  type: "",
  name: "",
  email: "",
  mobileNumber: "",
  modules: [],
  permissions: {},
};

export const extractAccessData = (payload) =>
  payload?.data ?? payload ?? null;

const toAccessLevel = (item = {}) => {
  if (item.write) return ACCESS_LEVEL.readWrite;
  if (item.read) return ACCESS_LEVEL.read;
  return null;
};

export const normalizeAccessData = (raw = {}) => {
  const permissionRows = Array.isArray(raw?.permissions) ? raw.permissions : [];
  const modules = [];
  const permissions = {};

  permissionRows.forEach((item) => {
    const name = item.moduleName || item.name || "";
    const level = toAccessLevel(item);
    if (!name || !level) return;

    modules.push({
      id: item.moduleId ?? item.id,
      name,
      label: getModuleLabel(name),
    });
    permissions[name] = level;
  });

  return {
    id: raw.id ?? raw.adminId ?? null,
    type: raw.type || "",
    name: raw.name || "",
    email: raw.email || "",
    mobileNumber: raw.mobileNumber || "",
    modules,
    permissions,
  };
};
